import React from 'react';

export default function Dialog({ children, ...props }) {
  const { open, onClose } = props;
  if (!open) {
    return <></>;
  }
  return (
    <div className='fixed inset-0 w-screen h-screen bg-white z-1300'>
      <span className='absolute top-0 z-20 p-4 right-5'>
        <button onClick={() => onClose()} aria-label='close'>
          <svg xmlns='http://www.w3.org/2000/svg' className='w-5 h-5' viewBox='0 0 20 20' fill='currentColor'>
            <path
              fillRule='evenodd'
              d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
              clipRule='evenodd'
            />
          </svg>
        </button>
      </span>
      <div className='relative flex w-full h-full'>{children}</div>
    </div>
  );
}
